export interface FollowableCta {
	href: string;
	openInNewTab?: boolean;
}

export function followCta(cta: FollowableCta): void {
	if (cta.openInNewTab) {
		window.open(cta.href, "_blank", "noopener");
		return;
	}
	window.location.assign(cta.href);
}
